import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { Card, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import axios from "axios";

import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDSnackbar from "components/MDSnackbar";

export default class UpdateUniversity extends Component {
  state = {
    id: "",
    name: "",
    short_name: "",
    city: "",
    state_name: "",
    status: "active",
    notification: false,
    message: "",
    redirect: false,
    loading: false,
  };

  componentDidMount() {
    const id = window.location.pathname.split("/")[2];
    this.setState({ id });
    if (id) {
      this.getSingleUniversity(id);
    }
  }

  getSingleUniversity = async (id) => {
    try {
      if (init() === "success") {
        const resp = await axios.get(Constants.getUrls.getSingleUniversity + id);
        const college = resp?.data?.data;
        this.setState({
          name: college?.name || "",
          short_name: college?.short_name || "",
          city: college?.city || "",
          state_name: college?.state || "",
          status: college?.status || "active",
        });
      }
    } catch (error) {
      this.setState({
        notification: true,
        message: error?.response?.data?.message || "Failed to load college details.",
      });
    }
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ loading: true });

    const payload = {
      name: this.state.name,
      short_name: this.state.short_name,
      city: this.state.city,
      state: this.state.state_name,
      status: this.state.status,
    };

    if (init() === "success") {
      axios
        .put(Constants.putUrls.updateUniversity + this.state.id, payload)
        .then((resp) => {
          this.setState({
            loading: false,
            notification: true,
            message: resp.data.message,
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "", redirect: true });
          }, 2500);
        })
        .catch((err) => {
          this.setState({
            loading: false,
            notification: true,
            message: err?.response?.data?.message || "Failed to update college.",
          });
        });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/colleges" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Update College
              </MDTypography>
            </MDBox>
            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container sm={12} spacing={2}>
                  <Grid item sm={6}>
                    <InputLabel>College Name</InputLabel>
                    <TextField
                      type="text"
                      name="name"
                      value={this.state.name}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                      required
                    />
                  </Grid>
                  <Grid item sm={6}>
                    <InputLabel>Short Name</InputLabel>
                    <TextField
                      type="text"
                      name="short_name"
                      value={this.state.short_name}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item sm={6}>
                    <InputLabel>City</InputLabel>
                    <TextField
                      type="text"
                      name="city"
                      value={this.state.city}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item sm={6}>
                    <InputLabel>State</InputLabel>
                    <TextField
                      type="text"
                      name="state_name"
                      value={this.state.state_name}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item sm={6}>
                    <InputLabel>Status</InputLabel>
                    <Select
                      value={this.state.status}
                      onChange={(e) => this.setState({ status: e.target.value })}
                      style={{ width: "100%", height: "45px" }}
                    >
                      <MenuItem value="active">Active</MenuItem>
                      <MenuItem value="inactive">Inactive</MenuItem>
                    </Select>
                  </Grid>
                </Grid>

                <Grid align="left" mt={2}>
                  <MDButton variant="contained" size="small" color="info" type="submit">
                    {this.state.loading ? "Updating..." : "Update"}
                  </MDButton>
                </Grid>
              </form>
            </MDBox>
            <MDSnackbar
              color="success"
              icon="notifications"
              title="AgriQuiz"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
